import React from 'react';
import classes from './BuildControls.css';
import BuildControl from './BuildControl/BuildControl';

// array of possible controls (each element is an object that contains a visual label plus the the case sensive type that could be passed in as a prop)
const controls = [
        {label: 'Lettuce', type: 'lettuce'},
        {label: 'Bacon', type: 'bacon'},
        {label: 'Cheese', type: 'cheese'},
        {label: 'Meat', type: 'meat'}
];
const buildControls = (props) =>
(
    <div className = {classes.BuildControls}>
        <p>Current Price: <strong>{props.price.toFixed(2)}</strong> </p>
        {controls.map(ctrl => ( // ctrl being each element iterated over from the array
            <BuildControl
             key = {ctrl.label}
             label = {ctrl.label}
             added = {() =>props.ingredientAdded (ctrl.type)} // passes in our ingredient to add 
             removed = {() => props.ingredientRemoved (ctrl.type)}
             disabled = {props.disabled[ctrl.type]}
            />
        ))}
        <button
            className = {classes.OrderButton}
            disabled = {!props.purchasable}
            onClick = {props.ordered}>ORDER NOW</button>
    </div>
);

export default buildControls;


// WEBPACK FOOTER //
// ./src/components/Burger/BuildControls/BuildControls.js